// CSS
import styles from "./vimeo.module.scss";

const Vimeo = (props) => {
    const { video } = props;
    const { vimeo_id } = video || {};

    return (
        <>
            <div className={styles.wrapper}>
                <iframe
                    allow="autoplay; fullscreen; picture-in-picture"
                    allowFullScreen
                    className={styles.iframe}
                    frameBorder="0"
                    src={`https://player.vimeo.com/video/${vimeo_id}`}
                    title="Vimeo embed"
                ></iframe>
            </div>
        </>
    );
};

export default Vimeo;
